import { useRegisterRuleGroup } from './rule-group-registration-context';
export const CollapsibleRuleGroup = _ref => {
  let {
    children,
    ...ruleGroup
  } = _ref;
  useRegisterRuleGroup(ruleGroup);
  return null;
};
//# sourceMappingURL=collapsible-rule-group.js.map